import React from 'react';

const TimeoutModal = ({ show, onClose, translations, email }) => {
  if (!show) return null;

  return (
    <div
      style={{
        position: "fixed",
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        backgroundColor: "rgba(0,0,0,0.5)",
        zIndex: 1000,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
      }}
    >
      <div
        style={{
          background: "white",
          padding: "30px",
          borderRadius: "10px",
          maxWidth: "500px",
          width: "90%",
          boxShadow: "0 5px 20px rgba(0,0,0,0.3)",
          textAlign: "center",
        }}
      >
        <h4 style={{ marginBottom: "15px" }}>
          {translations.reportGenerationTakingLonger}
        </h4>
        <p>{translations.reportGenerationMessage}</p>
        <p style={{ fontWeight: "bold", wordBreak: "break-all" }}>
          {email}
        </p>
        <p>{translations.reportGenerationClose}</p>
        <button className="btn btn-primary mt-3" onClick={onClose}>
          {translations.close}
        </button>
      </div>
    </div>
  );
};

export default TimeoutModal;